import React from "react";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import GavelIcon from "@mui/icons-material/Gavel";
import BusinessIcon from "@mui/icons-material/Business";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import routes from "../../../constants/routes";
import useStyles from "./registerChoice.style";

const accountTypes = [
  {
    key: "bidder",
    icon: GavelIcon,
    title: "Bidder",
    description:
      "Register as an individual to browse auctions and place your bids.",
    benefits: [
      "Bid on live and upcoming auctions",
      "Track the lots you are watching",
      "Quick sign up with your personal details",
    ],
    buttonLabel: "Register as Bidder",
    path: routes.bidderRegister,
  },
  {
    key: "company",
    icon: BusinessIcon,
    title: "Company",
    description:
      "Register your business to list lots and run your own auctions.",
    benefits: [
      "Create and manage your auctions",
      "Company profile with business details",
      "Access to seller tools and APIs",
    ],
    buttonLabel: "Register as Company",
    path: routes.companyRegister,
  },
];

function RegisterChoice() {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className="container">
      <Box className={classes.wrapper}>
        <Typography className={classes.heading}>CREATE AN ACCOUNT</Typography>
        <Typography className={classes.subHeading}>
          Tell us how you would like to use V3bid and we will take you to the
          right registration form.
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {accountTypes.map((accountType) => {
            const Icon = accountType.icon;

            return (
              <Grid item xs={12} md={5} key={accountType.key}>
                <Card className={classes.card} variant="outlined">
                  <Icon className={classes.icon} />
                  <Typography className={classes.cardTitle}>
                    {accountType.title}
                  </Typography>
                  <Typography className={classes.cardText}>
                    {accountType.description}
                  </Typography>
                  <ul className={classes.list}>
                    {accountType.benefits.map((benefit) => (
                      <li className={classes.listItem} key={benefit}>
                        <CheckCircleOutlineIcon className={classes.checkIcon} />
                        {benefit}
                      </li>
                    ))}
                  </ul>
                  <Button
                    fullWidth
                    className={classes.button}
                    onClick={() => navigate(accountType.path)}
                  >
                    {accountType.buttonLabel}
                  </Button>
                </Card>
              </Grid>
            );
          })}
        </Grid>

        <Typography className={classes.signInText}>
          Already have an account? <Link to={routes.signin}>Sign In</Link>
        </Typography>
      </Box>
    </div>
  );
}

export default RegisterChoice;
